export class IncomingCallModel {

  public callerId: string = null as any;
  public callerName: string = null as any;
}
